// These are needed because unfortunately we seem to be ending up with multiple
// discrete copies of rxjs, and unless we add the operators here, sometimes
// they don't work.

import * as ramda from 'ramda';
import {combineEpics} from 'redux-observable';

import {Accounts} from 'nutshell-core/accounts';
import {Billing} from 'nutshell-core/billing';
import * as Contacts from 'nutshell-core/contacts';
import {Session} from 'nutshell-core/session';
import {Tasks} from 'nutshell-core/tasks';

import * as ConnectedFormEpics from './ui/connected-forms/connected-forms-epics';
import * as AnalyticsEpic from './ui/email-marketing/analytics/report/analytics-epics';
import * as AudienceEpics from './ui/email-marketing/audiences/audiences-epics';
import * as EditionEpics from './ui/email-marketing/editions/editions-epics';
import * as McfxCompaniesEpics from './ui/email-marketing/visitors/companies-list/companies-epics';
import * as WebFormEpics from './ui/forms/forms-epics';
import * as ChatEpics from './ui/inbox/dashboard/report/chat/chat-epics';
import * as FacebookEpics from './ui/inbox/dashboard/report/facebook/facebook-epics';
import * as InstagramEpics from './ui/inbox/dashboard/report/instagram/instagram-epics';
import * as SMSEpics from './ui/inbox/dashboard/report/sms/sms-epics';
import * as WhatsAppEpics from './ui/inbox/dashboard/report/whatsapp/whatsapp-epics';
import * as LandingPageEpics from './ui/landing-pages/report/pages-epics';
import * as CompletedActionsEpics from './ui/reports/engagement/completed-actions/completed-actions-epics';
import * as EngagementLeadsEpics from './ui/reports/engagement/leads/leads-epics';
import * as EngagementSalesEpics from './ui/reports/engagement/sales/sales-epics';
import * as WidgetOpensEpics from './ui/reports/engagement/widget-opens/widget-opens-epics';
import * as ReportEpics from './ui/reports/reports-epics';

export const rootEpic = combineEpics(
    ...Accounts.epics,
    ...Billing.epics,
    ...Contacts.epics,
    ...Session.epics,
    ...Tasks.epics,
    ...ramda.values(ReportEpics),
    ...ramda.values(AudienceEpics),
    ...ramda.values(EditionEpics),
    ...ramda.values(WebFormEpics),
    ...ramda.values(ConnectedFormEpics),
    ...ramda.values(AnalyticsEpic),
    ...ramda.values(McfxCompaniesEpics),
    ...ramda.values(LandingPageEpics),
    ...ramda.values(ChatEpics),
    ...ramda.values(SMSEpics),
    ...ramda.values(FacebookEpics),
    ...ramda.values(InstagramEpics),
    ...ramda.values(WhatsAppEpics),
    ...ramda.values(EngagementLeadsEpics),
    ...ramda.values(EngagementSalesEpics),
    ...ramda.values(WidgetOpensEpics),
    ...ramda.values(CompletedActionsEpics)
);
